
export default {
  props: {
    links: { type: Array, default: () => [] },
    selectedIndex: { type: Number, default: -1 },
  }
};
